import { ShaderCompiler } from "@/shader-compiler";

// TODO: check when this import runs and catch the error, maybe delay until `compile` calls.
// Imported via the "@" alias so Jest's moduleNameMapper can substitute an
// fs-based mock (the real module uses import.meta.glob, which Jest can't run).
const shaders = import("@/layers/shaders/all");

export const shaderCompiler = new ShaderCompiler(shaders);
